const lineItemAttributeSetter = {
    bound: false,
    running: false,

    log: function() {
        if (window.location.hash == "#enable-lias-debug") {
            console.log('lineItemAttributeSetter:', ...arguments);
        }
    },

    getStoreId: function() {
        return localStorage.getItem('store_id') || null;
    },

    getStoreName: function() {
        return localStorage.getItem('store_name') || null;
    },

    init: function() {
        if (this.bound) {
            return;
        }
        this.bound = true;

        let _this = this;

        document.addEventListener("cart:ready", (e) => {
            _this.log('trigger:', "cart:ready");
            _this.run();
        });

        document.addEventListener("cart:updated", (e) => {
            _this.log('trigger:', "cart:updated");
            _this.run();
        });

        document.addEventListener("cartStoreChanged", (e) => {
            _this.log('trigger:', "cartStoreChanged");
            _this.run();
        });

        fetch('/cart.js')
            .then(res => res.json())
            .then(cartData => {
                let storeId = cartData.attributes._store_id ?? _this.getStoreId();
                _this.log("storeId on load:", storeId);
                if (storeId) {
                    _this.log("calling run:");
                    _this.run();
                }
            });
    },

    run: function() {
        this.log("run called", this.running);
        if (!this._running) {
            this.log("starting run");
            this.running = true;
            let _this = this;

            fetch('/cart.js')
                .then(res => res.json())
                .then(cartData => {
                    _this.log("cart.js came back...");
                    
                    let storeId = cartData.attributes._store_id ?? _this.getStoreId();
                    let storeName = cartData.attributes['Store Name'] ?? _this.getStoreName();

                    if (!storeId) {
                        _this.log("No store_id available - done");
                        _this.running = false;
                        return;
                    }

                    let needsCartAttributeUpdate = !cartData.attributes._store_id && storeId;
                    
                    if (needsCartAttributeUpdate) {
                        _this.log("Updating cart attributes with store_id:", storeId);
                        fetch('/cart/update.js', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            },
                            body: JSON.stringify({
                                attributes: {
                                    _store_id: storeId,
                                    'Store Name': storeName || ''
                                }
                            })
                        });
                    }

                    let changePromises = cartData.items.filter((item) => {
                        return item.properties?._store_id != storeId;
                    }).map((item) => {
                        let newProperties = {
                            ...item.properties,
                            _store_id: storeId
                        };
                        return () => new Promise((resolve) => {
                            _this.log("Property update promise " + item.key);
                            fetch('/cart/change.js', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({
                                    id: item.key,
                                    quantity: item.quantity,
                                    properties: newProperties
                                })
                            })
                            .then(res => res.json())
                            .then(data => {
                                resolve(data);
                            });
                        });
                    });

                    if (changePromises.length) {
                        _this.log("Updating " + changePromises.length + " items...");
                        Promise.all(
                            changePromises.map(promise => promise().then(() => {
                                _this.log('[1 cart item updated]');
                            }))
                        ).then(() => {
                            _this.log("All items updated - done");
                            _this.running = false;
                        });
                    } else {
                        _this.log("Nothing to update - done");
                        _this.running = false;
                    }
                })
                .catch((e) => {
                    _this.log("error (- done)", e);
                    _this.running = false;
                });
        }
    }
};

document.addEventListener('DOMContentLoaded', function() {
    lineItemAttributeSetter.init();
});
